import React from 'react';
import Fragment from 'react-dot-fragment';
import OneVisualLayout from "../../layouts/one-visual";

import Image from '../../../../containers/assets/pf6.png';

const CareerPathwayStep5 = () => (
  <OneVisualLayout
    section="CAREER PATHWAY"
    title="Finance &amp; Accounting"
    paragraph1={(
      <Fragment>
        The finance &amp; accounting functions are vital to a company's survival. A business
        cannot execute strategy without some form of capital. Nor can a business survive and
        thrive if they are not monitoring their actions through the control, measurement,
        and reporting of their financial performance.
      </Fragment>
    )}
    paragraph2={(
      <Fragment>
        Ruth Porat, Google's CFO, is a great example of the power and influence of these functions.
        Ruth joined Google in 2015 and instantly made an impact. She was instrumental in restructuring
        the tech giant from Google to now Alphabet, put in place tighter controls to reign in on Google's
        spending binge, and made data more transparent throughout the organization to help managers
        better align strategic initiatives with financial results. The rise in Google's stock price
        provides just a glimpse of her impact.
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default CareerPathwayStep5;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/career-pathway/step5.js